import axiosInstance from '../axiosInstance';

export const getSearchQna = async ({
  keyword,
  page = 0,
  sort = 'Most Relevant',
  searchIn = 'All',
  onlyAnswered = false,
  categoryIds = [],
}) => {
  try {
    const response = await axiosInstance.get('/qna/search', {
      params: {
        keyword,
        page,
        sort,
        searchIn,
        onlyAnswered,
        categoryId: categoryIds.join(','),
      },
    });

    return response.data.data;
  } catch (error) {
    console.error('Search QnA API Error:', error);
    throw error;
  }
};
